export default "__VITE_ASSET__cb36a5a6__"